import createPermissionEvent from '@fe/zxwy-utils/tool/permission'

export { getLoginMark, Permission } from '@fe/zxwy-utils/tool/permission'

export const { getLoginOriginMark, setLoginOriginMark, clearLoginOriginMark, loginValidate } = createPermissionEvent(process.env.NODE_ENV)
